import React from 'react';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import type { SearchFieldActions, SearchFieldState } from '../../hooks';
import { AccountModel, KhachHang } from '@/types/schemas';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}
const DetailTab = ({ formState: { state, actions } }: DetailTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-40'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          value={state.khachHang?.customer_code || ''}
          relatedFieldValue={state.khachHang?.customer_name || ''}
          onRowSelection={actions.setKhachHang}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40'>Tài khoản nợ</Label>
        <SearchField<AccountModel>
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={state.taikhoanNo?.code || ''}
          relatedFieldValue={state.taikhoanNo?.name || ''}
          onRowSelection={actions.setTaiKhoanNo}
        />
      </div>
    </div>
  );
};

export default DetailTab;
